<template>
  <div class="app-container">
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="待发货订单" name="Todo"></el-tab-pane>
      <el-tab-pane label="已发货订单" name="Done"></el-tab-pane>
    </el-tabs>
    <order-todo ref="orderTodo" v-if="tabName == 'Todo'">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="90">
          <template slot-scope="{row}">
            <template v-if="!row.isLock">
              <!-- <div>
                <el-button type="text" @click="checkAddress(row)">核对地址</el-button>
              </div> -->
              <div>
                <el-button type="text" @click="openPrint(row)">打印</el-button>
                <el-button type="text" @click="openPrintWithSend(row)">发货</el-button>
              </div>
            </template>
            <div>
              <el-button type="text" v-if="!row.isLock" @click="setLockState(row, 0)">锁定</el-button>
              <el-button type="text" v-else @click="setLockState(row, 1)">解锁</el-button>
              <el-dropdown @command="selectFlag($event, row)" style="margin-left: 10px;">
                <el-button type="text">插旗</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">
                    <div class="flag"><i class="el-icon-s-flag flag-red"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="1">
                    <div class="flag"><i class="el-icon-s-flag flag-orange"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="2">
                    <div class="flag"><i class="el-icon-s-flag flag-yellow"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="3">
                    <div class="flag"><i class="el-icon-s-flag flag-green"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="4">
                    <div class="flag"><i class="el-icon-s-flag flag-blue"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="5">
                    <div class="flag"><i class="el-icon-s-flag flag-indigo"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="6">
                    <div class="flag"><i class="el-icon-s-flag flag-purple"></i></div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <template v-if="row.isPrint">
              <div>
                <el-button type="text" @click="onUpdateExpressSheet(row)">更新面单</el-button>
              </div>
              <div>
                <el-button type="text" @click="onRecycle(row)">回收单号</el-button>
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
    </order-todo>
    <order-done ref="orderDone" v-if="tabName == 'Done'">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="90">
          <template slot-scope="{row}">
            <div>
              <el-button type="text" @click="openPrint(row)">打印</el-button>
            </div>
            <div>
              <el-button type="text" @click="onRecycle(row)">回收单号</el-button>
            </div>
          </template>
        </el-table-column>
      </template>
    </order-done>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import orderTodo from "@/components/printandship/orderTodo/list";
import orderDone from "@/components/printandship/orderDone/list";

export default {
  name: "printandship",
  mixins: [curdMixins],
  components: {
    orderTodo,
    orderDone,
  },
  data() {
    return {
      tabName: "Todo"
    }
  },
  methods: {
    handleClick(e) {
      console.log("handleClick", e)
      this.$nextTick(() => {
        this.reload();
      });
    },
    reload() {
      this.$refs["order" + this.tabName].reload();
    },
    checkAddress(row) {
      this.$refs["order" + this.tabName].checkAddress(row);
    },
    openPrint(row) {
      this.$refs["order" + this.tabName].openPrint(row);
    },
    openPrintWithSend(row) {
      this.$refs["order" + this.tabName].openPrintWithSend(row);
    },
    selectFlag(command, row) {
      console.log("selectFlag", command);
      // row.Field6_1 = command;
    },
    //设置锁定状态，0：锁定，1：解锁
    setLockState(row, state) {
      var msg = "确定" + (state == 0 ? "锁定" : "解锁") + "此订单吗？";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (state == 0) {
          console.log("锁定");
        } else {
          console.log("解锁");
        }
      }).catch(() => { });
    },
    //更新面单
    onUpdateExpressSheet(row) {
      this.$refs["order" + this.tabName].onUpdateExpressSheet(row);
    },
    onRecycle(row) {
      this.$refs["order" + this.tabName].onRecycle(row);
    },
  },
};
</script>
<style lang="scss">
.flag {
  width: 30px;
  font-size: 14px;
  text-align: center;

  i {
    margin: 0;
  }
}
</style>